// Año footer
document.getElementById("y").textContent = new Date().getFullYear();

// Cristales flotando (ligero)
const holder = document.querySelector(".hero__crystals");
if (holder) {
  const count = 14;
  for (let i = 0; i < count; i++) {
    const el = document.createElement("span");
    el.className = "crystal";
    el.style.left = Math.random() * 100 + "%";
    el.style.top = Math.random() * 100 + "%";
    el.style.animationDelay = (Math.random() * 3).toFixed(2) + "s";
    el.style.animationDuration = (4 + Math.random() * 6).toFixed(2) + "s";
    holder.appendChild(el);
  }

  // Inyecta CSS de cristales (para no inflar styles.css)
  const css = document.createElement("style");
  css.textContent = `
    .crystal{
      position:absolute;
      width:${10}px;height:${10}px;
      border-radius:4px;
      background: radial-gradient(circle at 30% 30%, rgba(255,255,255,.85), rgba(44,195,181,.25));
      border:1px solid rgba(255,255,255,.35);
      box-shadow: 0 18px 40px rgba(0,0,0,.18);
      transform: rotate(25deg);
      opacity:.85;
      animation: floaty linear infinite;
    }
    @keyframes floaty{
      0%{ transform: translateY(0) rotate(25deg); opacity:.35; }
      30%{ opacity:.9; }
      100%{ transform: translateY(-80px) rotate(55deg); opacity:.35; }
    }
  `;
  document.head.appendChild(css);
}
